<template>
  <div id="trainer-schools">
    <!-- Pull up their data, with an add button -->
    <!-- table of students -->
    <b-container id="trainer-schools-table" fluid>
      <b-row class="mt-4">
        <b-col cols="6" class="mr-4">
          <br />
          <b-col>
            <h4 class="subtitle">
              Trainer's Current Schools ({{ schoolsTable.length || 0 }})
            </h4>
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-table
              v-cloak
              responsive
              :fields="trainerSchoolsFields"
              :items="schoolsTable"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered"
            >
              <template slot="cell(school_name)" slot-scope="row">
                <b-link
                  @click.stop="stopClick"
                  :to="{
                    name: 'EditSchool',
                    params: { id: row.item.school_uuid },
                  }"
                  >{{ row.item.school_name }}</b-link
                >
                <br />
                <p class="small-date">village: {{ row.item.village }}</p>
              </template>
              <template slot="cell(active)" slot-scope="row">
                <b-form-radio-group
                  :id="row.item.id.toString()"
                  v-if="isAdmin || isSRC"
                  :value="row.item.active"
                  v-model="row.item.active"
                  @change="updateTrainerSchool(row)"
                >
                  <b-form-radio :value="true">Y</b-form-radio>
                  <b-form-radio :value="false">N</b-form-radio>
                </b-form-radio-group>
              </template>
              <template slot="cell(delete)" slot-scope="row">
                <b-link
                  class="delete"
                  v-if="isAdmin || isSRC"
                  @click.stop="deleteTrainerSchool(row.item)"
                  >Delete Link</b-link
                >
              </template>
            </b-table>
            <b-row>
              <b-col md="6" class="m-4">
                <b-pagination
                  :total-rows="schoolsTable.length || 0"
                  :per-page="perPage"
                  v-model="currentPage"
                  class="my-0"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col cols="1"></b-col>
        <b-col v-if="isAdmin || isSRC" cols="4">
          <div class="table-wrap">
            <br />
            <h4 class="subtitle">Add Schools</h4>
            <div>
              <name-search
                table="schools"
                parent="trainer-schools"
              ></name-search>
            </div>
            <br />
            <div v-if="getSchoolSearchResults.length">
              <b-col>
                <h6 class="subtitle">
                  Results: {{ getSchoolSearchResults.length }} schools found
                </h6>
                <b-form-group>
                  <b-input-group>
                    <b-form-input
                      v-model="filterSearchResults"
                      placeholder="Type to Search"
                    />
                    <b-input-group-append>
                      <b-btn
                        :disabled="!filterSearchResults"
                        @click="filterSearchResults = ''"
                        >Clear</b-btn
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <div id="alerts" ref="trainer-schools-alert">
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="success"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                    >You have successfully added a school!</b-alert
                  >
                  <b-alert :show="showError" dismissible variant="warning">
                    Something went wrong. Please refresh and try again, or
                    contact the site admin.
                  </b-alert>
                </div>
              </b-col>
              <b-table
                v-cloak
                responsive
                :fields="searchResultsFields"
                :items="getSchoolSearchResults"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                small
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filterSearchResults"
                @filtered="onFilteredResults"
              >
                <template slot="cell(school_name)" slot-scope="row">
                  <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditSchool', params: { id: row.item.id } }"
                    >{{ row.item.school_name }}</b-link
                  >
                  <br />
                  <p class="small-date">village: {{ row.item.village }}</p>
                </template>
                <template slot="cell(id)" slot-scope="row">
                  <b-link class="add" @click.stop="addSchoolToTrainer(row)"
                    >ADD</b-link
                  >
                </template>
              </b-table>
              <b-row>
                <b-col md="6" class="my-1">
                  <b-pagination
                    :total-rows="getSchoolSearchResults.length || 0"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TrainerService from "../services/TrainerService";
import NameSearch from "@/components/NameSearch";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "TrainerSchools",
  mixins: [flash, scrollTo],
  components: {
    NameSearch,
  },
  data() {
    return {
      trainerId: this.$route.params.id ? this.$route.params.id : null,
      isDisabled: true,
      country: "",
      region: "",
      district: "",
      village: "",
      trainerSchoolsFields: [
        { key: "school_name", label: "Name", sortable: true },
        { key: "active", label: "Active?", sortable: true },
        { key: "delete", label: "DELETE" },
      ],
      searchResultsFields: [
        { key: "school_name", label: "Name", sortable: true },
        { key: "id", label: "ADD" },
      ],
      file: this.$route.path.slice(1),
      currentPage: 1,
      country: "",
      perPage: 20,
      pageOptions: [20, 50, 100],
      filter: null,
      filterSearchResults: null,
    };
  },
  methods: {
    ...mapActions({
      GET_TRAINER_SCHOOLS: "trainers/GET_TRAINER_SCHOOLS",
      RESET_TRAINERS_STATE: "trainers/RESET_TRAINERS_STATE",
      RESET_SEARCH: "searches/RESET_SEARCH_STATE",
    }),
    async searchSchools() {
      await this.SEARCH_LOCATION();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredResults(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async updateTrainerSchool(params) {
      const payload = await {
        id: params.item.id,
        student_id: params.item.student_id,
        student_uuid: params.item.student_uuid,
        teacher_uuid: this.$route.params.id,
        active: !params.item.active,
      };
      await TrainerService.updateTrainerSchool(payload);
      await this.GET_TRAINER_SCHOOLS();
    },
    async addSchoolToTrainer(params) {
      console.log(params);
      const payload = await {
        school_uuid: params.item.uuid,
        trainer_uuid: this.$route.params.id,
        active: true,
      };
      await TrainerService.addTrainerSchool(payload);
      await this.scrollTo("trainer-schools-alert");
      await this.flashSuccess();
      await this.GET_TRAINER_SCHOOLS();
    },
    async deleteTrainerSchool(params) {
      const confirmDelete = confirm(
        "Are you sure you want to remove this school from this trainer?"
      );
      console.log(params);
      if (confirmDelete) {
        await TrainerService.deleteTrainerSchool(params);
        await this.GET_TRAINER_SCHOOLS();
      }
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      getGeo: "searches/getGeo",
      getSchoolSearchResults: "searches/getSchoolSearchResults",
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    schoolsTable: {
      get() {
        return this.$store.state.trainers.trainerSchools;
      },
    },
    trainerSchools: {
      get() {
        return this.$store.state.trainers.trainerSchools;
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.trainerSchoolsFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.GET_TRAINER_SCHOOLS();
  },
};
</script>

<style scoped>
.add {
  color: green;
  font-weight: bold;
}

.small-date {
  font-style: italic;
  font-size: 10px;
  color: #5a6269;
}

table th,
table tr {
  text-align: center;
  word-break: break-all;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.delete {
  color: #9f020f;
  font-weight: bold;
}
</style>
